import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useV2Auth } from '@/context/V2AuthContext';
import { PrimaryAction, MaskPageBack } from '@/components/mask/MaskSystem';
import '@/components/mask/mask.css';

/* MOMENTS 1.0 — Übersicht der eigenen Momente (Initiator) */

export default function MomentsListV2() {
  const { user, API_V2 } = useV2Auth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [moments, setMoments] = useState(null);

  useEffect(() => {
    document.body.classList.add('cc-no-overlays');
    return () => document.body.classList.remove('cc-no-overlays');
  }, []);

  useEffect(() => {
    if (!user) return;
    axios.get(`${API_V2}/moments`, { withCredentials: true })
      .then((res) => setMoments(res.data))
      .catch((err) => { if (err.response?.status === 401) navigate('/auth', { replace: true }); else setMoments([]); });
  }, [user, API_V2, navigate]);

  if (!user || moments === null) return <div className="min-h-[60vh] flex items-center justify-center"><p className="text-sm text-[var(--muted)]">{t('v2.common.loading')}</p></div>;

  return (
    <div className="relative min-h-[calc(100vh-4rem)] overflow-x-hidden" data-testid="moments-list-page">
      <div className="mask-bg-word mask-bg-top" aria-hidden="true"><span style={{ transform: 'translateX(-8%)' }}>{t('v2.bgWords.momente')}</span></div>
      <div className="relative z-10 w-full max-w-2xl mx-auto px-6 sm:px-8 pt-10 pb-28">
        <MaskPageBack onClick={() => navigate('/profile')} data-testid="moments-back-btn" />
        <header className="mb-16">
          <p className="mask-enter text-xs uppercase tracking-[0.2em] text-[var(--muted)] mb-5">{t('v2.moments.label')}</p>
          <h1 className="mask-enter mask-enter-delay-1 mask-headline text-3xl sm:text-4xl text-[var(--text)] mb-6">
            {t('v2.moments.listHeadline')}
          </h1>
          <PrimaryAction onClick={() => navigate('/momente/neu')} data-testid="moments-create-btn">{t('v2.moments.create')}</PrimaryAction>
        </header>

        {moments.length > 0 && (
          <section className="space-y-8" data-testid="moments-list">
            {moments.map((m) => (
              <button key={m.id} type="button" onClick={() => navigate(`/momente/${m.id}`)} data-testid={`moment-item-${m.id}`}
                className="mask-room-item block w-full text-left">
                <span className="block mask-headline text-xl sm:text-2xl text-[var(--text)]/85">{t('v2.common.for', { name: m.recipientName })}</span>
                <span className="block text-xs uppercase tracking-[0.15em] text-[var(--muted)] mt-1.5">
                  {m.occasion} · {m.contributionCount} {m.contributionCount === 1 ? t('v2.moments.contributionOne') : t('v2.moments.contributionMany')} · {m.status === 'released' ? t('v2.moments.released') : t('v2.moments.inProgress')}
                </span>
              </button>
            ))}
          </section>
        )}
      </div>
    </div>
  );
}
